import React from 'react';
import PropTypes from 'prop-types';

function Accepted(props) {
  const ratio = 44 / 45;

  return (
    <svg width={props.size} height={Math.floor(props.size * ratio)} viewBox="0 0 45 44" xmlns="http://www.w3.org/2000/svg">
      <path d="M42.45 21.898C42.45 10.908 33.54 2 22.55 2 11.562 2 2.654 10.91 2.654 21.898c0 10.99 8.908 19.898 19.896 19.898 10.99 0 19.9-8.908 19.9-19.898zm2 0c0 12.094-9.805 21.898-21.9 21.898-12.092 0-21.896-9.804-21.896-21.898S10.458 0 22.55 0c12.095 0 21.9 9.804 21.9 21.898zm-30.78-1.445l-1.416 1.414 6.66 6.66 12.283-12.28-1.414-1.416-10.87 10.87-5.244-5.247z" fillRule="nonzero" fill="#5df9a5" />
    </svg>
  );
}

Accepted.defaultProps = {
  size: 45,
};

Accepted.propTypes = {
  size: PropTypes.number,
};

export default Accepted;
